<template>
  <header class="app-header">
    <div class="top-bar">
      <div class="grid-x grid-padding-x align-middle">
        <div class="top-bar__app-icon cell shrink">
          <router-link to="/"><img src="../assets/img/logo/logo.png"
                                   alt="Visceral Apps"></router-link>
        </div>

        <div id="main-menu" class="cell auto show-for-large">
          <ul class="top-bar__menu">
            <li><router-link :to="{ name: 'home'}"
                             :class="[this.$route.name === 'home' ? 'active' : '']">Dashboard</router-link>
            </li>
            <li><router-link :to="{ name: 'vendorsList'}"
                             :class="[this.$route.name === 'vendorsList' || this.$route.name === 'vendorsSingle' ? 'active' : '']">Vendors</router-link>
            </li>
            <li><router-link :to="{ name: 'ordersList'}"
                             :class="[this.$route.name === 'ordersList' || this.$route.name === 'ordersSingle' ? 'active' : '']">Orders</router-link>
            </li>
            <li><router-link :to="{ name: 'productsList' }"
                             :class="[this.$route.name === 'productsList' ? 'active' : '']">Products</router-link>
            </li>
            <li><router-link :to="{ name: 'payoutsList' }"
                             :class="[this.$route.name === 'payoutsList' ? 'active' : '']">Payouts</router-link>
            </li>
            <li><router-link :to="{ name: 'AccountsList' }"
                             :class="[this.$route.name === 'AccountsList' ? 'active' : '']">Accounts</router-link>
            </li>
          </ul>
        </div>

        <div class="cell auto large-shrink text-right">
          <ul class="top-bar__menu top-bar__menu--icons"
              style="border-right: 1px solid #333333; display: inline-block; margin-right: 25px; padding-right: 15px;">
<!--            <li><a-->
<!--              :href="'https://' + $store.state.shop.myshopify_domain + '/admin/app_store/redirect?url=https://apps.shopify.com/vendor-consignment?#modal-show=ReviewListingModal'"-->
<!--              target="_blank">-->
<!--              <i class="fas fa-star"></i> <span class="show-for-medium">write a Review</span></a>-->
<!--            </li>-->
            <li><router-link :to="{ name: 'helpDashboard' }"
                             :class="[this.$route.name === 'helpDashboard' ? 'active' : '']"><i
              class="fa-question-circle fas"></i> Help</router-link></li>
            <li><router-link :to="{ name: 'settingsGeneral' }"
                             :class="[this.$route.name === 'settingsGeneral' ? 'active' : '']">
              <i class="fa-cog fas"></i> Settings</router-link></li>
          </ul>

          <ul class="top-bar__menu top-bar__menu--icons" style="display: inline-block;">
            <li><a :href="params" target="_blank">
              <i :class="['fas', iframe ? 'fa-expand-alt' : 'fa-compress-alt']"></i>
            </a></li>

            <li class="hide-for-large">
              <a @click="openMenu"><i class="fa-bars fas"></i></a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="page-actions__wrapper">
      <div class="page-actions">
        <div class="grid-container">
        </div>
      </div>
    </div>

    <div id="flash-message" class="flash-message" v-if="message">
      <div class="grid-x grid-padding-x">
        <div class="cell">

          <div class="callout alert">
            <p></p>
          </div>

          <div class="callout success">
            <p></p>
          </div>
        </div>
      </div>
    </div>

    <transition name="slide-fade">
      <progressBar v-if="syncing"></progressBar>
    </transition>
  </header>
</template>

<script>
import progressBar from './progressBar'
import env from '@/mixins/env'

export default {
  components: {
    progressBar
  },
  data: function () {
    return {
      params: '/?' + env.params(),
      syncing: false,
      message: false,
      iframe: true,
      menuOpen: false
    }
  },
  methods: {
    sync () {
      this.syncing = true
    },
    openMenu () {
      let menu = document.getElementById('main-menu')

      if (this.menuOpen) {
        menu.className = 'cell auto show-for-medium'
      } else {
        menu.className = 'cell auto open show-for-medium'
      }

      this.menuOpen = !this.menuOpen
    }
  },
  watch: {
    $route (to, from) {
      let menu = document.getElementById('main-menu')

      menu.className = 'cell auto show-for-large'

      this.menuOpen = false
    }
  },
  created () {
    function inIframe () {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    }

    if (!inIframe()) {
      this.iframe = false
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';

.app-header {
  padding-top: 56px;
  margin-bottom: 15px;
}

.top-bar {
  background: #222222;
  border-bottom: 1px solid var(--secondary-color);
  left: 0;
  padding: 6px 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;

  &__app-icon {
    text-align: center;

    img {
      height: 30px;
    }
  }

  &__title {
    color: $white;
    display: inline-block;
    line-height: 1;
    margin-bottom: 0;
  }

  &__menu {
    margin: 0 0 0 -15px;

    li {
      display: inline-block;
    }

    a {
      @include transition(background .25s);
      border-radius: 5px;
      display: inline-block;
      color: $white;
      padding: 6px 15px;

      &:hover {
        background: $darkest-gray;
        color: $white;
      }

      &.active {
        background: var(--secondary-color);
      }
    }

    &--icons {
      a {
        @include transition(color .25s);
        padding: 6px 10px;
      }
    }
  }
}

.light-theme {
  .top-bar {
    background: #fafafa;

    &__menu {
      a {
        color: $darkest-gray;

        &:hover {
          background: $light-gray;
        }

        &.active {
          background: var(--secondary-color);
          color: $white;
        }
      }

      &--icons {
        a {
          color: $darkest-gray;
        }
      }
    }
  }
}

#main-menu.open {
  background: #222222;
  border-bottom: 1px solid var(--secondary-color);
  display: block !important;
  left: 0;
  position: absolute;
  right: 0;
  top: 100%;

  .top-bar {
    &__menu {
      margin: 0 -15px 0;

      li {
        display: block;
      }

      a {
        @include transition(background .25s);
        border-radius: 5px;
        display: block;
        color: $white;
        padding: 10px 15px;
        text-align: center;

        &:hover {
          background: $darkest-gray;
          color: $white;
        }

        &.active {
          background: var(--secondary-color);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/header.vue